import { faCircle as faCircleRegular } from "@fortawesome/pro-regular-svg-icons/faCircle";
import { faCirclePlay } from "@fortawesome/pro-regular-svg-icons/faCirclePlay";
import { faCircle as faCircleSolid } from "@fortawesome/pro-solid-svg-icons/faCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo, useState } from "react";
import { BuildLigthBoxSlides, CardLightBox } from "views/knowledge/components/card/behaviors/common/CardLightbox";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";
import { FeedItemAttachInfo } from "views/knowledge/components/card/FeedItemHelper";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/styles.css";

////////////////////////////////////////////////////////////////////////////////

interface RenderImageProps {
    attach?: FeedItemAttachInfo;
    count: number;
}

const RenderImage: React.FC<RenderImageProps> = ({ attach, count }) => {

    if (!attach) return null;

    return (
        <>
            <div style={{ position: "relative", width: attach.image.width, height: attach.image.height, margin: "0 auto" }}>
                <img
                    id={`card-img-${attach.attachId}`}
                    src={attach.image.url}
                    style={{
                        width: "100%", height: "100%",
                        objectFit: "contain"
                    }} />
            </div>
            {
                count > 1 &&
                <div style={{ textAlign: "center", marginTop: 4 }}>
                    {
                        Array.from({ length: count }).map((_, index) => <FontAwesomeIcon key={index} size="xs" icon={index == 0 ? faCircleSolid : faCircleRegular} fixedWidth />)
                    }
                </div>
            }
        </>);
};

////////////////////////////////////////////////////////////////////////////////

export const DefaultMedia = () => {
    const { pub: { publicationId, presentation, attachs }, helper, onMarkRead } = useCardContext();
    const [openLightbox, setOpenLightbox] = useState<boolean>(false);

    const slides = useMemo(() => (
        presentation && attachs
            ? BuildLigthBoxSlides(presentation, attachs, presentation.rotationInterval == 0)
            : []
    ), [publicationId, presentation, attachs]);

    const firstImage = useMemo(() => (
        helper.cardImage()
    ), [publicationId]);

    const handleClick = () => {
        if (onMarkRead) onMarkRead();
        setOpenLightbox(true);
    };

    return (!attachs || !presentation || presentation.orderedItems?.length == 0)
        ? null
        : (
            <div style={{ position: "relative", cursor: "pointer" }} onClick={handleClick}>
                <RenderImage attach={firstImage} count={presentation.orderedItems.length} />

                {firstImage && firstImage.showPlayIcon &&
                    <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} >
                        <FontAwesomeIcon icon={faCirclePlay} size="5x" color="white" />
                    </div>
                }

                <CardLightBox
                    slides={slides}
                    open={openLightbox}
                    index={0}
                    autoplay={presentation.rotationInterval > 0}
                    rotationInterval={presentation.rotationInterval}
                    onClose={() => setOpenLightbox(false)}
                />
            </div>
        );
};
